import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import CompanyLogo from './Assets/magna.png';
import bgImage from './Assets/bg.png';
import LoginVector from './Assets/login-vector.png';

const LoginPage = () => {
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const staticUser = { username: 'magnaglobal', password: 'M@gn@1234' };
  const navigate = useNavigate();

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      await new Promise((resolve) => setTimeout(resolve, 900));
      if (formData.username === staticUser.username && formData.password === staticUser.password) {
        navigate('/main-menu');
      } else {
        setErrorMessage('Invalid username or password. Please try again.');
      }
    } catch (error) {
      console.error('Login error:', error);
      setErrorMessage('An error occurred during login. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div
      className="relative flex min-h-screen items-center justify-center bg-cover bg-center"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      {/* Left Side - Illustration */}
      <div className="flex w-1/2 items-center justify-center z-10 hidden lg:flex">
        <img src={LoginVector} alt="Login Illustration" className="w-3/5 h-auto object-contain" />
      </div>

      {/* Right Login Form Section */}
      <div className="flex w-full lg:w-1/2 items-center justify-center z-10 px-6">
        <div className="w-full max-w-md p-10 rounded-3xl shadow-2xl bg-white">
          <div className="flex justify-center">
            <img src={CompanyLogo} alt="Company Logo" className="h-20" />
          </div>
          <h2 style={{ textAlign: 'center', fontSize: '20px', marginBottom: '20px' }}>Google Maps API Demo</h2>

          {errorMessage && (
            <div className="mb-4 text-red-600 bg-red-100 p-3 rounded-lg text-center">
              {errorMessage}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-gray-700 text-sm font-medium mb-1" htmlFor="username">
                Username
              </label>
              <input
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 transition duration-150 ease-in-out"
                placeholder="Enter your username"
                required
              />
            </div>
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                Password
              </label>
              <div className="relative mt-1">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 transition duration-150 ease-in-out"
                  placeholder="Enter your password"
                  required
                />
                <button
                  type="button"
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="w-full bg-gradient-to-r from-blue-600 to-blue-500 text-white py-3 rounded-full font-semibold hover:from-blue-500 hover:to-blue-600 transition-all duration-500 ease-in-out shadow-md hover:shadow-lg transform hover:-translate-y-1 flex items-center justify-center"
              disabled={isLoading}
            >
              {isLoading ? (
                <div className="flex space-x-2">
                  <div className="h-2.5 w-2.5 bg-white rounded-full animate-bounce" style={{ animationDelay: '0s' }}></div>
                  <div className="h-2.5 w-2.5 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
                  <div className="h-2.5 w-2.5 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
                </div>
              ) : (
                'Sign in'
              )}
            </button>
          </form>

          <div className="text-center text-gray-500 text-sm mt-6">
            © Smartnet Magna Global {new Date().getFullYear()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
